/* istanbul ignore file */

import Vue from "vue";
import store from "../store";
import TicketStore from "../components/ticket-store/TicketStore";
import StoreSwiper from "../components/swiper/StoreSwiper";
import Carousel from "../components/carousel/StoreCarousel";

const vueEl = "[data-vue-view='event-show']";

document.ready.then(() => {
  if (document.querySelector(vueEl)) {
    new Vue({
      el: vueEl,
      store,
      name: "EventShow",
      components: {
        "event-ticket-store": TicketStore,
        "store-swiper": StoreSwiper,
        carousel: Carousel,
      },
      mounted() {
        window._lytics_.attachEventListeners(this.$el);
      },
    });
  }
});
